import { Alert, Box } from "@mui/material";
import { SelectCarriers } from "@platform/carrier-components";
import {
  AI_DOCS_ACCEPTED_FILE_FORMATS,
  AI_DOCS_ACCEPTED_FILE_FORMATS_LABEL,
  DropzoneCustom,
  Typography,
} from "@platform/design-system";

import { FilesList } from "../components/FilesList";
import { useUploadFiles } from "../hooks";

import type { Carrier, UploadedFile } from "../types";

const MAX_FILE_SIZE_MB = 25;

interface UploadTabProps {
  carriers: Carrier[];
  selectedCarrier: string | null;
  onCarrierChange: (carrier: string | null) => void;
  isSubmitting?: boolean;
}

export function UploadTab({
  carriers,
  selectedCarrier,
  onCarrierChange,
  isSubmitting = false,
}: UploadTabProps): React.JSX.Element {
  const { files, handleUploadFiles, handleDeleteFile } = useUploadFiles();
  return (
    <>
      <SelectCarriers
        carriers={carriers.map((carrier) => carrier.name)}
        selectedCarrier={selectedCarrier}
        onCarrierChange={onCarrierChange}
        allowRequestNewCarrier
        disableRemove={isSubmitting}
      />
      <Typography variant="body-large" mt={2}>
        Proposal Documents
      </Typography>
      <DropzoneCustom
        files={files.map((f: UploadedFile) => ({
          name: f.name,
          downloadLink: "",
          size: f.file.size,
          infected: false,
          type: f.file.type,
        }))}
        handleUploadFiles={handleUploadFiles}
        onFileDelete={(dropzoneFile) => {
          const match = files.find(
            (f: UploadedFile) => f.name === dropzoneFile.name,
          );
          if (match) handleDeleteFile(match);
        }}
        maxMbSize={MAX_FILE_SIZE_MB}
        acceptedFormatFiles={AI_DOCS_ACCEPTED_FILE_FORMATS}
        allowedFormatLabel={AI_DOCS_ACCEPTED_FILE_FORMATS_LABEL}
        isMultiple
        showFiles={false}
      />
      <Box mt={2}>
        <FilesList
          files={files}
          onDeleteFile={handleDeleteFile}
          isSubmitting={isSubmitting}
        />
      </Box>

      <Box mt={2}>
        <Alert severity="info">
          AI parsing may take a few moments, please allow up to 15 minutes for
          AI parsing.
        </Alert>
      </Box>
    </>
  );
}
